import { match } from 'ts-pattern'

export const quoteFieldLabel = (fieldName: string): string =>
  match(fieldName)
    .with('dealstage', () => 'Deal stage')
    .with('closedate', () => 'Close date')
    .with('dealname', () => 'Deal name')
    .with('amount', () => 'Amount')
    .with('pipeline', () => 'Pipeline')
    .with('hubspot_owner_id', () => 'Deal owner')
    .with('sequence_quote_id', () => 'Sequence quote ID')
    .otherwise(humanisePropertyName)

const humanisePropertyName = (fieldName: string): string => {
  const words = fieldName.replaceAll('_', ' ').toLowerCase()

  return `${words.charAt(0).toUpperCase()}${words.slice(1)}`
}
